<template>
<section>
    <social-header v-if="currentEnv" title="车主认证"></social-header>
<!--表单-->
	<div class="identification">
        <p class="identification-tips" v-if="ownerInfo!==null&&ownerInfo.auditState===10">{{ownerInfo.reason}}</p>
		<div class="identification_upload">
			<h3>成为认证车主</h3>
			<p>若您已获得驾驶证、行驶证，可上传证件照片进行认证，我们会对您的信息严格保密（图片不超过5M，拍摄清晰无反光）</p>
			<div class="identification_photo clearfix">
				<div class="identification_photo-col fl" v-bind:class="{'uploaded':certificateImages.length>0&&!firstChoosed}">
					<a href="javascript:;" v-on:click="chooseFirst()" v-stat:click="{name:'owner_choose_first'}">
						<div>
							<img v-if="certificateImages.length===0&&!firstChoosed" src="https://dealer2.autoimg.cn/dealerdfs/g26/M09/D3/B1/autohomedealer__wKgHHVtFpv6AUd_HAAAvjC7rasE231.png" alt="">
                            <img v-if="certificateImages.length>0&&!firstChoosed" v-bind:src="certificateImages[0].certificateImage" alt="">
                            <img v-if="firstChoosed" v-bind:src="firstImgurl" alt="">
							<p class="identification_photo-camera">
								<img src="https://dealer2.autoimg.cn/dealerdfs/g28/M07/D2/B6/autohomedealer__wKgHI1tFd4uAcY8WAAAFGjtJqQg541.png" alt="">
							</p>
						</div>
						<p>上传驾驶证</p>
					</a>
				</div>
				<div class="identification_photo-col fr" v-bind:class="{'uploaded':certificateImages.length>1&&!secondChoosed}">
					<a href="javascript:;" v-on:click="chooseSecond()" v-stat:click="{name:'owner_choose_second'}">
						<div>
							<img v-if="certificateImages.length<=1&&!secondChoosed" src="https://dealer2.autoimg.cn/dealerdfs/g30/M04/D4/EA/autohomedealer__ChcCSVtFpxKAMqIIAAAuv-BrRXA565.png" alt="">
                            <img v-if="certificateImages.length>1&&!secondChoosed" v-bind:src="certificateImages[1].certificateImage" alt="">
                            <img v-if="secondChoosed" v-bind:src="secondImgurl" alt="">
							<p class="identification_photo-camera">
								<img src="https://dealer2.autoimg.cn/dealerdfs/g28/M07/D2/B6/autohomedealer__wKgHI1tFd4uAcY8WAAAFGjtJqQg541.png" alt="">
							</p>
						</div>
						<p>上传行驶证</p>
					</a>
				</div>
			</div>
			<div class="identification_photo clearfix">
				<div class="identification_photo-demo fl">
					<img src="https://dealer2.autoimg.cn/dealerdfs/g27/M02/D4/1D/autohomedealer__wKgHHltFp0-AaLCKAAJ37U-xixk824.png" alt="">
					<p>驾驶证示例</p>
				</div>
				<div class="identification_photo-demo fr">
					<img src="https://dealer2.autoimg.cn/dealerdfs/g27/M0A/D4/59/autohomedealer__ChcCQFtFp0OASOTxAAHq1m2f3VY632.png" alt="">
					<p>行驶证示例</p>
				</div>
			</div>
		</div>
		<div class="identification_submit">
			<a class="common-btn blue-big-btn" v-bind:class="{'disabled':submitDisabled}" href="javascript:;" v-on:click="confirm()" v-stat:click="{name:'owner_confirm'}">{{submitText}}</a>
		</div>
		<div class="identification_proto">
			<label><input type="checkbox" v-model="isAgree">我已阅读并同意</label><router-link :to="{path:'/certificate/agreement'}" v-stat:click="{name:'agreement'}" class="font-blue">《个人信息保护声明》</router-link>
		</div>
	</div>
	<!--表单-->
	<!--确认弹层-->
	<div class="confirm-pop" v-bind:class="{'fn-hide':confirmHide}">
		<div class="msk"></div>
		<div class="confirm-box">
			<h3>确认提交</h3>
			<p>提交后，审核期间信息不可修改</p>
			<div class="confirm-btns">
				<a class="font-gray" href="javascript:;" v-on:click="confirmHide=true">返回修改</a>
				<a href="javascript:;" v-on:click="submit()" v-stat:click="{name:'owner_submit'}">提交审核</a>
			</div>
		</div>
	</div>
	<!--确认弹层-->
    <social-dialog title="正在加载" category="tips" v-bind:show="dialogShow"></social-dialog>
</section>
</template>

<script>
  import {
    mapGetters
  } from 'vuex'
  import SocialHeader from '../../components/social-header.vue'
  import SocialDialog from '../../components/social-dialog.vue'
  import Environment from '../../service/environment.service.js'
  import Dialog from '../../plugins/dialog.js'
  import { isWeiXin, isDingDing, changeDocumentTitle } from '../../service/environment'

  export default {
    components: {
      SocialHeader,
      SocialDialog
    },
    name: 'CertificateOwner',
    data: function () {
      return {
        isAgree: true,
        firstChoosed: false,
        secondChoosed: false,
        firstImgurl: '',
        secondImgurl: '',
        firstOriginUrl: '',
        secondOriginUrl: '',
        dialogShow: false,
        confirmHide: true
      }
    },
    created: function () {
      var current = this
      changeDocumentTitle('保险代理人认证')
      current.dialogShow = true
      current.$store.dispatch('resetCertificateImages')
      current.$store.dispatch('getCertificateInfo').then(function () {
        current.dialogShow = false
      })
    },
    computed: {
      submitText () {
        let text = '提交审核'
        let ownerCertificate = this.certificateInfo.filter(t => t.certificateType === 0)
        if (ownerCertificate.length > 0) {
          let info = ownerCertificate[0]
          if (info.auditState === 0) {
            text = '审核中'
          } else {
            if (!this.firstChoosed || !this.secondChoosed || !this.isAgree) {
              if (info.auditState === 5) {
                text = '认证通过'
              }
            }
          }
        }
        return text
      },
      ownerInfo () {
        var current = this
        let ownerCertificate = current.certificateInfo.filter(t => t.certificateType === 0)
        if (ownerCertificate.length > 0) {
          current.dialogShow = true
          current.$store.dispatch('getCertificateImages', ownerCertificate[0].id).then(function () {
            current.dialogShow = false
          })
          return ownerCertificate[0]
        }
        return null
      },
      submitDisabled () {
        var current = this
        if (current.ownerInfo !== null && current.ownerInfo.auditState === 0) {
          return true
        } else {
          return !current.isAgree || !current.firstChoosed || !current.secondChoosed
        }
      },
      ...mapGetters({
        certificateInfo: 'certificateInfo',
        certificateImages: 'certificateImages'
      }),
      currentEnv () {
        if (isWeiXin()) {
          return false
        } else if (isDingDing()) {
          return false
        } else {
          return true
        }
      }
    },
    methods: {
      chooseFirst () {
        if (this.ownerInfo !== null && this.ownerInfo.auditState === 0) {

        } else {
          let current = this
      // 选择微信图片
          if (window.entrance.name !== 'wx' && window.entrance.name !== 'mainapp') {
            Dialog.toast({title: '请在微信或主app环境中打开此页面', timeout: 1000})
            return false
          }
          Environment.chooseImage(function (data) {
        // 微信的id或者本地图片的物理地址
            current.firstOriginUrl = data.imgId
        // 微信的id（可以直接显示）或者app的base64图片信息
            current.firstImgurl = data.imgBase64 || data.imgId
            current.firstChoosed = true
          })
        }
      },
      chooseSecond () {
        if (this.ownerInfo !== null && this.ownerInfo.auditState === 0) {

        } else {
          let current = this
      // 选择微信图片
          if (window.entrance.name !== 'wx' && window.entrance.name !== 'mainapp') {
            Dialog.toast({title: '请在微信或主app环境中打开此页面', timeout: 1000})
            return false
          }
          Environment.chooseImage(function (data) {
        // 微信的id或者本地图片的物理地址
            current.secondOriginUrl = data.imgId
        // 微信的id（可以直接显示）或者app的base64图片信息
            current.secondImgurl = data.imgBase64 || data.imgId
            current.secondChoosed = true
          })
        }
      },
      confirm () {
        if (this.ownerInfo !== null && this.ownerInfo.auditState === 0) {

        } else {
          if (!this.isAgree) {
            Dialog.toast({title: '请阅读并同意《个人信息保护声明》!'})
            return
          }
          if (!this.firstChoosed) {
            Dialog.toast({title: '请上传驾驶证!'})
            return
          }
          if (!this.secondChoosed) {
            Dialog.toast({title: '请上传行驶证!'})
            return
          }
          this.confirmHide = false
        }
      },
      // 提交
      submit () {
        let current = this
        current.confirmHide = true
        current.dialogShow = true
        Environment.upload(current.firstOriginUrl, function (firstData) {
          Environment.upload(current.secondOriginUrl, function (secondData) {
            let firstServerId = firstData.imgId // 返回图片的服务器端ID，只有微信才有
            let firstImgBase64 = firstData.imgBase64
            let secondServerId = secondData.imgId // 返回图片的服务器端ID，只有微信才有
            let secondImgBase64 = secondData.imgBase64
            var param = {
              certificateType: 0,
              images: [{wxMediaId: firstServerId, imageBase64: firstImgBase64}, {wxMediaId: secondServerId, imageBase64: secondImgBase64}]
            }
            current.$store.dispatch('certificateSubmit', param).then(function () {
              current.dialogShow = false
              current.firstChoosed = false
              current.secondChoosed = false
            })
          })
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/certificate/owner.vue